import { FolderOutlined, LocalShippingOutlined, PersonOutlined, SmartButtonOutlined } from '@mui/icons-material'
import { Tab, Tabs } from '@mui/material'

import useStyles from '../index.styles'

const TabsComponent = ({ tabIndex, handleTabChange }: { tabIndex: number; handleTabChange: (_event: React.SyntheticEvent, newValue: number) => void }) => {
  const classes = useStyles
  return (
    <Tabs value={tabIndex} onChange={handleTabChange} aria-label="search-tabs">
      <Tab label="Accounts" icon={<FolderOutlined />} iconPosition="start" sx={classes.searchTab} />
      <Tab label="People" icon={<PersonOutlined />} iconPosition="start" sx={classes.searchTab} />
      <Tab label="Devices" icon={<SmartButtonOutlined />} iconPosition="start" sx={classes.searchTab} />
      <Tab label="Orders" icon={<LocalShippingOutlined />} iconPosition="start" sx={classes.searchTab} />
    </Tabs>
  )
}
export default TabsComponent
